// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PriceUnitPriceAndRating_wrapper__Nk2AI","priceAndUnitPrice":"PriceUnitPriceAndRating_priceAndUnitPrice__wHpSs"};